import { render } from "./EndorsementDetailList.vue?vue&type=template&id=6254ad18&scoped=true"
import script from "./EndorsementDetailList.vue?vue&type=script&lang=js"
export * from "./EndorsementDetailList.vue?vue&type=script&lang=js"

import "./EndorsementDetailList.vue?vue&type=style&index=0&id=6254ad18&scoped=true&lang=css"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6254ad18"]])

export default __exports__